exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.overlay[data-v-a018b38c]{z-index:-999;left:0;background:rgba(11,10,12,.35);opacity:0;width:100%;transition:opacity .3s ease}aside.sidebar[data-v-a018b38c],div.overlay[data-v-a018b38c]{position:fixed;top:0;height:100%}aside.sidebar[data-v-a018b38c]{z-index:9999;will-change:transform;transition:transform .3s ease;background:#fff;width:300px;overflow-y:auto;overflow-x:hidden;word-wrap:break-word}", ""]);

// exports
